import { c } from '../../../utils/tailwind-merge';
import { Badge } from '../../atoms/Badge/Badge';
import { BadgeListProps } from './BadgeList.types';

export const BadgeList = ({ badges, className = '' }: BadgeListProps) => {
  return (
    <div className={c('flex w-full items-start gap-x-2', className)}>
      {badges && badges.map((badge) => <Badge key={badge.text} {...badge} />)}
    </div>
  );
};
